/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `DocumentedSystemRadioGroup` for the Caintra Connect frontend.
 * @module components/AppointmentRegistrationSections/Certifications/DocumentedSystemRadioGroup
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
import { FIELD_VALIDATION_ERROR_BORDER_STYLE } from "../../../utils/formValidationConstants.js";

const DOCUMENTED_SYSTEM_OPTIONS = [
  {
    id: "hasADocumentedQualityManagementSystemYes1",
    value: 0,
    labelKey:
      "components.certifications.hasADocumentedQualityManagementSystemYes1",
    className: "specialRadioOption",
  },
  {
    id: "hasADocumentedQualityManagementSystemYes2",
    value: 1,
    labelKey:
      "components.certifications.hasADocumentedQualityManagementSystemYes2",
    className: "specialRadioOption",
  },
  {
    id: "hasADocumentedQualityManagementSystemNo",
    value: 2,
    labelKey: "components.certifications.hasADocumentedQualityManagementSystemNo",
    className: "",
  },
];

const DocumentedSystemRadioGroup = ({
  documentedSystem,
  onChange,
  getFieldValidation,
  missingRequiredFields,
  isTablet,
  t,
  styles,
}) => (
  <div
    className={`${styles.inputRow} ${isTablet ? styles.tabletInputRow : ""}`}
  >
    <div className={styles.inputGroup}>
      <label className={styles.inputLabel}>
        {t(
          "components.certifications.hasADocumentedQualityManagementSystemLabel",
        )}
        {missingRequiredFields &&
          Object.hasOwn(missingRequiredFields, "tieneSistemaDocumentado") && (
            <span className={styles.required}> *</span>
          )}
      </label>
      <div
        className={styles.radioColumn}
        style={
          getFieldValidation && getFieldValidation("tieneSistemaDocumentado")
            ? FIELD_VALIDATION_ERROR_BORDER_STYLE
            : undefined
        }
      >
        {DOCUMENTED_SYSTEM_OPTIONS.map((option) => (
          <div
            key={option.id}
            className={`${styles.radioOption} ${
              option.className ? styles[option.className] : ""
            }`}
          >
            <input
              type="radio"
              id={option.id}
              name="hasADocumentedQualityManagementSystem"
              value={option.value}
              checked={documentedSystem === option.value}
              onChange={() => onChange(option.value)}
              className={styles.radio}
            />
            <label htmlFor={option.id} className={styles.radioLabel}>
              {t(option.labelKey)}
            </label>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default DocumentedSystemRadioGroup;
